import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section admin-help" }
const _hoisted_2 = { class: "thanks" }
const _hoisted_3 = {
  target: "_blank",
  href: "https://memories.gallery/install/"
}
const _hoisted_4 = {
  target: "_blank",
  href: "https://github.com/pulsejet/memories#-support-the-project"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('memories', 'Thank you for choosing Nextcloud and Memories to store your precious data!')), 1),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Memories is very feature rich and setting it up properly can take some time.')) + " ", 1),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'If you just installed Memories, make sure you read the getting started guide:')) + " ", 1),
    _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.t('memories', 'External Link')), 1),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'In case you run into any issues or bugs, you can get help through several channels.')) + " ", 1),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "https://discord.gg/7Dr9f9vNjJ",
          target: "_blank"
        }, "Discord community"),
        _createTextVNode(" (any questions, feedback, suggestions, etc.) ")
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          href: "https://github.com/pulsejet/memories/issues",
          target: "_blank"
        }, "GitHub issues"),
        _createTextVNode(" (bugs and feature requests) ")
      ])
    ], -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Memories is a completely free and open source app under active development.')) + " ", 1),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You can contribute in several ways. See the project page for more details:')) + " ", 1),
    _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.t('memories', 'External Link')), 1)
  ]))
}